export default "__VITE_ASSET__008222ad__"